/**
 *
 * UserNotAuthorizedModal
 *
 */

import React, { memo, useRef } from 'react';
import {
  Modal,
  ModalContent,
  ModalHeader,
  Button,
} from '@cashfree-intl/coherent';
import PropTypes from 'prop-types';
// import styled from 'styled-components';
import CustomIcon from '../CustomIcons';

import useClickOutside from '../../utils/hooks';

function UserNotAuthorizedModal({ open, resetErrorTitle }) {
  const modalRef = useRef(null);

  useClickOutside(modalRef, resetErrorTitle);

  return (
    <Modal
      size="tiny"
      open={open}
      className="common-modal-wrapper user-not-authorized-wrapper"
      ref={modalRef}
    >
      <ModalHeader>
        {/* eslint-disable-next-line */}
        <div
          className="close-modal"
          data-event-name="UserNotAuthorizedModal_Icon_Close"
          data-ignore-inner-text="true"
          onClick={resetErrorTitle}
        >
          <CustomIcon componentName="CLOSE" />
        </div>
      </ModalHeader>
      <ModalContent>
        <div className="modal-content">
          <div className="icon-wrapper">
            <CustomIcon componentName="EXCLAMAITON" fill="#D60000" />
          </div>
          <div className="title">Permission Denied</div>
          <div className="message text-light">
            Please contact your account owner to grant you permission
          </div>
          <div className="cta-wrapper">
            <Button fluid type="button" primary onClick={resetErrorTitle}>
              OK
            </Button>
          </div>
        </div>
      </ModalContent>
    </Modal>
  );
}

UserNotAuthorizedModal.propTypes = {
  open: PropTypes.bool.isRequired,
  resetErrorTitle: PropTypes.func.isRequired,
};

export default memo(UserNotAuthorizedModal);
